import React, { FC } from 'react';
import useSetupKeepState from '../../global/hooks/useSetupKeepState';
import CollectionMainContent from './components/CollectionMainContent/CollectionMainContent';

const Collection: FC = () => {
  const key = useSetupKeepState();
  if (key === 'replaceState') {
    return null;
  }
  return <CollectionMainContent key={key} />;
};

export default Collection;
